// extracted by mini-css-extract-plugin
export default {"label":"Textbox_label__GO4ML"};